import type { WebRuntimeConfig } from '@localagent/sdk';

let runtime: WebRuntimeConfig | null = null;

function bundleDeclaresRuntimeConfig(): boolean {
  const declared = import.meta.env.VITE_WEB_RUNTIME_CONFIG as string | undefined;
  return typeof declared === 'string' && declared.trim() !== '';
}

function buildTimeValue(...values: Array<string | undefined>): string | undefined {
  if (bundleDeclaresRuntimeConfig()) {
    throw new Error(
      'a public key was read before the web runtime config was installed — the host must await it before render (la ADR-d43ea)',
    );
  }
  return values.find((v) => typeof v === 'string' && v !== '');
}

// (la ADR-d43ea)
export function installWebRuntimeKeys(config: WebRuntimeConfig): void {
  if (runtime !== null) {
    throw new Error('the web runtime config is installed once per realm');
  }
  runtime = config;
}

export function stytchPublicToken(): string | undefined {
  if (runtime !== null) {
    return runtime.stytchPublicToken;
  }
  return buildTimeValue(
    import.meta.env.STYTCH_PUBLIC_TOKEN as string | undefined,
    import.meta.env.VITE_STYTCH_PUBLIC_TOKEN as string | undefined,
  );
}

export function stripePublishableKey(): string | undefined {
  if (runtime !== null) {
    return runtime.stripePublishableKey;
  }
  return buildTimeValue(
    import.meta.env.STRIPE_PUBLISHABLE_KEY as string | undefined,
    import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined,
  );
}

// (la ADR-6ff8f)
export function desktopDownloadsUrl(): string {
  if (runtime !== null) {
    if (runtime.desktopDownloadsUrl === null) {
      throw new Error(
        '/config.json carries no desktopDownloadsUrl — a pod from an older deployable served it to this bundle mid-rollout; reload once the rollout completes (la ADR-6ff8f)',
      );
    }
    return runtime.desktopDownloadsUrl;
  }
  const value = buildTimeValue(import.meta.env.VITE_DESKTOP_DOWNLOADS_URL as string | undefined);
  if (value === undefined) {
    throw new Error(
      'VITE_DESKTOP_DOWNLOADS_URL is not defined — the host build must declare the desktop downloads channel (la ADR-6ff8f)',
    );
  }
  return value.replace(/\/+$/, '');
}
